export const PLANT = process.env.REACT_APP_PLANT || "";
